import { render, staticRenderFns } from "./utterance-entities.vue?vue&type=template&id=9f67c222&scoped=true"
import script from "./utterance-entities.ts?vue&type=script&lang=ts&external"
export * from "./utterance-entities.ts?vue&type=script&lang=ts&external"
import style0 from "./utterance-entities.less?vue&type=style&index=0&id=9f67c222&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f67c222",
  null
  
)

export default component.exports